
import React, { useState } from 'react'

import {  Input } from 'antd'
import moment from 'moment'
import { useParams } from 'react-router-dom';
import { ClientsDataTable } from '../ClientsDataTable';
import { useGetServiceByEmailQuery } from '../../../services/service/services.service';

export const PaymentData = () => {
    const { Search } = Input;

    const [searchText, setSearchText] = useState('')
    const [filteredResults, setFilteredResults] = useState([]);
    const [order, setOrder] = useState("ACS");
    const {clientsId} = useParams()

    const response = useGetServiceByEmailQuery(clientsId)

    const { data ,isLoading, isFetching, isSuccess, isError, error} = response

    const _data = data?.data?.Items

    const onSearch = (value) => {
        setSearchText("payment")
        if(value !== ''){
            const filteredData = _data.filter((item) => {
                return Object.values(item).join('').toLocaleLowerCase().includes("payment".toLocaleLowerCase())
            })
            setFilteredResults(filteredData)
        }else{
            setFilteredResults(_data)
        }
    }
   
    const Sorting = (value) => {
        let sortedData;
        const field= value
        if (order === 'ACS') {
            sortedData = [..._data].sort((a, b) => {
            return a[field].localeCompare(b[field]);
            });
            setOrder("DCS")
        } else if (order === 'DCS') {
            sortedData = [..._data].sort((a, b) => {
                return b[field].localeCompare(a[field]);
            })
            setOrder("ACS")
        } else {
            return _data;
        }
        setSearchText("sort")
        setFilteredResults(sortedData)
    }

    const columns = [
        // {
        //     key: "cardID",
        //     title: "Card Number",
        //     dataIndex: ["paymentMethodDetail","cardID"],
        // },
        {
            key: "isPayed",
            title: "Is Payed",
            dataIndex: ["paymentMethodDetail","isPayed"],
            render: (record) => record ? <p>Yes</p> : <p>No</p> 
        },
        {
            key: "isCash",
            title: "Is Cash",
            dataIndex: ["paymentMethodDetail","isCash"],
            render: (record) => record ? <p>Yes</p> : <p>No</p> 
        },
        {
            key: "price",
            title: "Price",
            dataIndex: ["paymentMethodDetail","price", "itemCost"],
        },
        {
            key: "tax",
            title: "Tax",
            dataIndex: ["paymentMethodDetail","price", "tax"],
        },
        {
            key: "tip",
            title: "Tip",
            dataIndex: ["paymentMethodDetail","price", "tip"],
        },
        {
            key: "cardID",
            title: "Washer",
            dataIndex: ["washerID"],
        },
        {
            key: "createdAt",
            title: "Created At",
            dataIndex: "createdAt",
            render: (createdAt) => ( <div> { moment(createdAt).format('L') } </div> ),
            onHeaderCell: () => { return { onClick: () => { Sorting("createdAt") } }},
        },
        {
            key: "updatedAt",
            title: "updated At",
            dataIndex: "createdAt",
            render: (updatedAt) => ( <div> { moment(updatedAt).format('L') } </div> ),
            onHeaderCell: () => { return { onClick: () => { Sorting("updatedAt") } }},
        },
    ]
 
    return (
            <div className='flex flex-col w-full justify-center'>
                <div className='flex items-center justify-between flex-wrap-reverse'>
                    <div className='mt-4 md:w-1/3 w-full'>
                        <Search
                            placeholder="input search text"
                            onSearch={onSearch} />
                    </div>
                </div>
                
                <ClientsDataTable
                    key={_data}
                    _data={ searchText ? filteredResults: _data}
                    columns={columns}
                    isError={isError}
                    isFetching={isFetching}
                    isLoading={isLoading}
                    error={error}
                    isSuccess={isSuccess}
                    className='w-full'
                />
            </div>
    )
}

